var exports = {
  "kL": "xa15a2ab7--346f20--container",
  "VA": "xa15a2ab7--346f20--subtitle",
  "h_": "xa15a2ab7--346f20--description",
  "qr": "xa15a2ab7--346f20--footer",
  "rD": "xa15a2ab7--346f20--archive",
  "ZT": "xa15a2ab7--346f20--cancel",
};

module.exports = exports;
